import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

/** True when the signed-in user owns at least one pioneer review (first to document an experience). */
export const usePioneerStatus = (userId?: string | null) => {
  const [isPioneer, setIsPioneer] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!userId) {
      setIsPioneer(false);
      setCount(0);
      return;
    }
    let active = true;
    (async () => {
      const { data } = await supabase
        .from("reviews_public" as any)
        .select("id")
        .eq("is_owner", true)
        .eq("is_pioneer", true);
      if (!active) return;
      const n = ((data as any[]) ?? []).length;
      setCount(n);
      setIsPioneer(n > 0);
    })();
    return () => {
      active = false;
    };
  }, [userId]);

  return { isPioneer, count };
};
